import {
	GET_INVOICE_SUCCESS,
	GET_INVOICE_FAILED,
	RESET_GET_INVOICE,
	LOADING_GET_INVOICE,
	NETWORK_ERROR_GET_INVOICE
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_GET_INVOICE:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case  GET_INVOICE_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case  GET_INVOICE_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_GET_INVOICE:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_GET_INVOICE:
			return (state = initialState);
		default:
			return state;
	}
};
